import React from "react";

const ManageStaff = () => {
  return (
    <div className="d-flex justify-content-end mt-5">
      <div className="form-header">Manage Staff</div>
    </div>
  );
};

export default ManageStaff;
